import React from 'react';
import WidgetBase from './WidgetBase';
import OperationalChart from '../ChartOperational';

const StatusChartWidget = ({ ...data }) => {
	return (
		<WidgetBase cols={4} rows={1}>
			<OperationalChart {...data} />
		</WidgetBase>
	);
};

export default StatusChartWidget;
